export default "__VITE_ASSET__B7s0Pddx__"